import { slugify } from "../../utils/slugify.js";
import { Locale } from "../Locale.js";
import type { Subcategory, SubcategoryForCustomer } from "../Subcategory.js";
import type { SubscriptionVariant } from "../SubscriptionVariant.js";
import { subscriptionVariantNameMap } from "../names/subscriptionVariantNameMap.js";

export function findSubcategoryOfSubscriptionVariant<T extends Subcategory | SubcategoryForCustomer>(
	subcategories: T[],
	variant: SubscriptionVariant,
	assert: boolean,
): T | undefined;
export function findSubcategoryOfSubscriptionVariant<T extends Subcategory | SubcategoryForCustomer>(
	subcategories: T[],
	variant: SubscriptionVariant,
	assert: true,
): T;
export function findSubcategoryOfSubscriptionVariant<T extends Subcategory | SubcategoryForCustomer>(
	subcategories: T[],
	variant: SubscriptionVariant,
	assert: boolean,
): T | undefined {
	const subcategory = subcategories.find(({ urlSlug }) =>
		Object.values(Locale).every(
			(locale) => slugify(urlSlug[locale]) === slugify(subscriptionVariantNameMap[variant][locale]),
		),
	);

	if (!subcategory && assert) {
		throw new Error(`Subcategory ${variant} not found.`);
	}

	return subcategory;
}
